import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled, { css } from 'styled-components'
import SimpleBoardTable from './SimpleBoardTable'

import { useStore } from '../zustandStore'
import { shallow } from 'zustand/shallow'

const TABLE_SIZE_SOFT_CAP = 16

const PublicSimpleBoardPage = (props) => {
  const [query, setQuery] = useSearchParams()

  const pinnedPlayerSlugs = query.getAll('pin')

  const [flashingPlayerSlugs, setFlashingPlayerSlugs] = useState([])

  const {
    hasDivisions,
    divisionNames,
    divisions,
    players,
    // TEMP PLAYERS_NEW
    playersNew,
  } = useStore(state => ({
    hasDivisions: state.event.hasDivisions,
    divisionNames: state.event.divisionNames,
    divisions: state.divisions,
    players: state.players,
    playersNew: state.playersNew,
  }), shallow)

  // pins a player to the top
  const onClickPlayerRow = (clickedPlayerSlug) => (e) => {
    e.preventDefault()
    if (pinnedPlayerSlugs.includes(clickedPlayerSlug)) {
      setFlashingPlayerSlugs(flashingPlayerSlugs.filter(slug => slug !== clickedPlayerSlug))
      setTimeout(() => setFlashingPlayerSlugs([...flashingPlayerSlugs, clickedPlayerSlug]), 1)
    } else {
      setQuery({ pin: [...pinnedPlayerSlugs, clickedPlayerSlug] }, { replace: true })
    }
  }

  // removes pinned player
  const onClickPinnedPlayerRow = (clickedPlayerSlug) => (e) => {
    e.preventDefault()
    setFlashingPlayerSlugs(flashingPlayerSlugs.filter(slug => slug !== clickedPlayerSlug))

    setQuery({ pin: pinnedPlayerSlugs.filter((slug) => slug != clickedPlayerSlug) }, { replace: true })
  }

  const pinnedPlayers = players.filter(player => pinnedPlayerSlugs.includes(player.slug))
  const pinnedDivisions = hasDivisions
    ? divisions.map(divisionSlugs =>
      divisionSlugs.filter((divisionSlug) =>
        pinnedPlayerSlugs.includes(divisionSlug)
      )
    )
    : [[]]

  
  let playerBatches = []
  if (hasDivisions) {
    // TEMP PLAYERS_NEW
    playerBatches = divisions.map(playerSlugs => playerSlugs.map(slug => playersNew[slug]))
  } else {
    // dynamically split the players into 2 or 3 batches (or 1!) depending on how many
    // TABLE_SIZE_SOFT_CAP determines how many players per table will result in adding another
    // table, with a max of 3 tables (which is why it's a soft cap)
    const playerCount = players.length

    if (playerCount == null || !players) {
      return (null)
    }

    let numberOfBatches = 1
    if (playerCount) {
      if (playerCount <= TABLE_SIZE_SOFT_CAP) {
        numberOfBatches = 1;
      } else if (playerCount > TABLE_SIZE_SOFT_CAP && playerCount <= TABLE_SIZE_SOFT_CAP * 2) {
        numberOfBatches = 2
      } else {
        numberOfBatches = 3
      }
    }

    const batchSize = Math.ceil(playerCount / numberOfBatches)

    for (let i = 0; i < numberOfBatches; i++) {
      playerBatches.push(
        players.slice(
          i * batchSize,
          (i + 1) * batchSize
        )
      )
    }
  }
  
  let bottomPinnedPlayerSlug
  if (hasDivisions) {
    bottomPinnedPlayerSlug = pinnedDivisions.flat()[pinnedPlayerSlugs.length - 1]
  }

  return (
    <>
      <StyledPinnedTableWrapper>
        {hasDivisions ? (
          pinnedDivisions.map((divisionSlugs, i) => {
            if (divisionSlugs.length == 0) return null
            // TEMP PLAYERS_NEW
            const pinnedPlayersThisDivision = divisionSlugs.map(slug => playersNew[slug])
            const lastPlayerSlug = divisionSlugs[divisionSlugs.length - 1]
            return (
              <SimpleBoardTable
                key={i}
                tableClassName={`table-pinned gradient-background ${pinnedPlayers.length > 0 ? ' non-empty' : ''}`}
                wrapperClassName='table-wrapper-pinned'
                rowClassName='row-pinned'
                players={pinnedPlayersThisDivision} // TODO: convert to slugs only
                hasOddOffset={false}
                scaleBy={0.9}
                scaleByOnPhone={0.75}
                onClickPlayerRow={onClickPinnedPlayerRow}
                borderThicknessPx={lastPlayerSlug === bottomPinnedPlayerSlug ? 2 : null}
                flashingPlayerSlugs={flashingPlayerSlugs}
                disableAllAnimations
                groupTitle={divisionNames[i].toUpperCase()}
              />
            )
          })
        ) : (
          <SimpleBoardTable
            tableClassName = {`table-pinned gradient-background ${pinnedPlayers.length > 0 ? ' non-empty' : ''}`}
            wrapperClassName='table-wrapper-pinned'
            rowClassName='row-pinned'
            players={pinnedPlayers} // TODO: convert to slugs only
            hasOddOffset={false}
            scaleBy={0.9}
            scaleByOnPhone={0.75}
            onClickPlayerRow={onClickPinnedPlayerRow}
            borderThicknessPx={2}
            flashingPlayerSlugs={flashingPlayerSlugs}
            disableAllAnimations
          />
        )}
      </StyledPinnedTableWrapper>

      <StyledBoardWrapper pinnedPlayerCount={pinnedPlayerSlugs.length}>
        {playerBatches.map((playerBatch, i) => {
          const totalOffset = playerBatches.slice(0, i).reduce((sum, batch) =>(sum += batch.length), 0)
          const hasOddOffset = totalOffset % 2 !== 0
          return <SimpleBoardTable
            key={i}
            players={playerBatch} // TODO: convert to slugs only
            groupTitle={hasDivisions ? divisionNames[i].toUpperCase() : ''}
            wrapperClassName='table-non-pinned-wrapper'
            tableClassName='table-non-pinned'
            hasOddOffset={hasOddOffset}
            scaleBy={0.9}
            scaleByOnPhone={0.75}
            onClickPlayerRow={onClickPlayerRow}
            // livePlayerSlugs={obsState.livePlayerSlugs}
          />
        })}
      </StyledBoardWrapper>
    </>
  )
}

export default PublicSimpleBoardPage

const StyledBoardWrapper = styled.div`

  --row-hover-color: var(--blue-hover);
  --row-active-color: var(--blue-active);

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
  margin-bottom: 2.5em;
  padding-left: 2%;
  padding-right: 2%;
  max-width: min(94vw, 1200px);
  margin-left: auto;
  margin-right: auto;

  .row {
    min-width: unset;
  }

  .table-non-pinned-wrapper {
    height: fit-content;
  }

  .table-non-pinned {
    &:not(.no-border-top) {
      border-top: 1px solid #aaa;
    }
    border-bottom: 1px solid #aaa;
    max-width: 26.25em;
    margin-left: 0.5em;
    margin-right: 0.5em;
  }

  @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) and (orientation: portrait) {
    flex-flow: column nowrap;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;

    .table-non-pinned {
      border: 0;
      max-width: 95vw;
    }

    .table-non-pinned-wrapper:first-child {
      .table-non-pinned {
        .row:first-child {
          border-top: 1px solid #aaa;
        }
      }
    }

    .table-non-pinned-wrapper:last-child {
      .table-non-pinned {
        .row:last-child {
          border-bottom: 1px solid #aaa;
        }
      }
    }
  }

  .row:hover {
    border-top: 1px solid var(--every-other-row-color);
    border-bottom: 1px solid var(--every-other-row-color);
    cursor: pointer;
  }

  ${props => props.pinnedPlayerCount && props.pinnedPlayerCount > 0 && css`
    margin-top: 1.8em;
  `}
`

const StyledPinnedTableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  position: sticky;
  top: 0px;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;

  --row-hover-color: var(--red-hover);
  --row-active-color: var(--red-active);

  .table-wrapper-pinned {
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
    @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) and (orientation: portrait) {
      width: 100vw;
      max-width: 600px;
    }
  }

  .table-pinned {
    max-width: 470px;
    width: 470px;
    /* box-shadow: 8px 8px 10px rgba(0,0,0,0.75); */

    @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) and (orientation: portrait) {
      max-width: unset;
      width: 100%;
      box-shadow: none;
      .row {
        width: 100%;
        max-width: unset;
      }
    }
  }
  @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) and (orientation: portrait) {
    .border-bottom {
      box-shadow: 0px 10px 10px rgba(0,0,0,0.8);
      margin-top: 0px;
    }
  }

  .row-pinned:hover{
    &:not(:first-child) {
      border-top: 1px solid var(--every-other-row-color);
    }
    &:not(:last-child) {
      border-bottom: 1px solid var(--every-other-row-color);
    }
    cursor: pointer;
  }

`


